// Locales each CMS content type is translated in. Keep in sync with the CMS.
const BLOG_LOCALES = ['en', 'es', 'it'];
const CUSTOMERS_LOCALES = ['en'];

const langPrefix = (lang) => (lang === 'en' ? '' : `/${lang}`);

module.exports = { BLOG_LOCALES, CUSTOMERS_LOCALES, langPrefix };
